import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {currentBrand} from './modules/brand/BrandContext';
import {resolveBrand} from './modules/brand/resolveBrand';

// Resolve the brand before the first render. Every deployed environment serves this page from
// nginx as a static file, so the brand block baked into the HTML is the build-time default and
// the real brand has to be fetched — see resolveBrand for why.
resolveBrand().then(() => {
    // The tab title names the lender, not the platform, so a borrower with several tabs open
    // can tell which loan they are paying.
    document.title = `Make a Payment - ${currentBrand().displayName}`;

    ReactDOM.render(
        <App/>,
        document.getElementById('root')
    );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
